export const UnreadNotificationsPill = ({ count }: { count: number }) => {
  const formatCount = (count: number) => {
    if (count < 20) return count;
    return `${Math.floor(count / 10) * 10}+`;
  };
  return (
    <div className="bg-info text-3xs flex h-4 w-fit max-w-6 items-center justify-center rounded-full px-1.5 text-white">
      {formatCount(count)}
    </div>
  );
};
